/* ⚛ REACT */
import { useEffect, useRef, useState } from "react";

/* 📦 LIBS */
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router";
import { useTranslation } from "react-i18next";

/* 🧩 COMPONENTS */
import { InputSelect, Input, InputCheckbox, Label, Button, CustomLoading, SaveIcon } from "../../../../Components";

/* 🔗 SERVICE */
import { PartsComandServices } from "../../../../Services/partscommandService";

/* 📁 ASSETS*/
import { Excluir } from "../../../../Assets/icons";

/* 🎨 STYLES */
import { Container, TitleContainer, Title, ContainerRow, ContainerColumn, ImageIcon, ButtonsContainer } from "./styles";

/* 🔧 UTILS */
import { isValidField } from "../../../../util/validate";

const ViewEquipamentHasPartCommands = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    document.title = "Edição de ligação de part Command - variável";
    const [loading, setLoading] = useState(true);
    const [parts, setParts] = useState([]);
    const [equipments, setEquipments] = useState([]);

    let { id } = useParams();
    const Services = useRef(new PartsComandServices());

    const partCommandField = useRef();
    const equipamentField = useRef();
    const custom_nameField = useRef();
    const keyField = useRef();
    const nameField = useRef();

    const partCommandValue = useRef();
    const equipamentValue = useRef();
    const custom_nameValue = useRef();
    const keyValue = useRef();
    const nameValue = useRef();
    const isActiveValue = useRef(false);

    
    const [partCommand, setPartCommand] = useState();

    useEffect(() => {
        async function getPartCommand(){
            setLoading(true)
            let currentItem = await Services.current.getEquipmentHasPartCommand(id);
            currentItem.equipmentId = currentItem.nbiot_id ? currentItem.nbiot_id : currentItem.poco_id;
            if(currentItem){
                isActiveValue.current = currentItem.active;
                setPartCommand(currentItem);
            }
            setLoading(false)
        }

        async function getParts(){
            let currentItem = await Services.current.getAllPartCommands();
            setParts(currentItem);
        }

        async function getEquipments(){
            let currentItem = await Services.current.getEquipments();
            setEquipments(currentItem);
        }

        getPartCommand();
        getEquipments();
        getParts();
    }, [id]);

    // method-spoofing
    // Salva as edições
    async function Save(){
        if(isValidField(partCommandValue.current)){
            let form = new FormData();
            if(partCommandValue.current){form.append('part_command', partCommandValue.current)}
            if(equipamentValue.current){form.append('id_equipment', equipamentValue.current)}
            if(custom_nameValue.current){form.append('custom_name', custom_nameValue.current)}
            if(keyValue.current){form.append('key', keyValue.current)}
            if(nameValue.current){form.append('name', nameValue.current)}
            form.append('active', isActiveValue.current ? 1 : 0)  

            form.append('_method', 'PATCH')

            let currentitem = await Services.current.editEquipmentHasPartsCommand(id, form)
            if(currentitem){
                currentitem.equipmentId = currentitem.nbiot_id ? currentitem.nbiot_id : currentitem.poco_id;
                setPartCommand(currentitem);
            }
        }else{
            toast(t("message.save"), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
    }

    return (
        <>  
            <Container>
                <TitleContainer>
                    <Title>Conexão de part Command - Equipamento</Title>
                </TitleContainer>

                {loading ? <CustomLoading width={'150px'} height={'150px'}/>:
                <>
                    <ContainerRow onSubmit={(e)=> e.preventDefault()}>
                        <ContainerColumn>
                            <Label text={"part Command"} aling="flex-start"/>
                            <InputSelect
                                key={'part_command'}
                                name={'part_command'}
                                id={'part_command'}
                                placeholder={"Part Command"}
                                invalidMessage = {"Part Command inválido!"}
                                options={parts}
                                innerRef={partCommandField}
                                value={partCommand?.part_command_id}
                                validationFunction = {(value) => isValidField(value)}
                                onchange={(value) => partCommandValue.current = value}>
                            </InputSelect> 

                            <Label text={"Nome Comando"} aling="flex-start"/>
                            <Input 
                                aling="flex-start"
                                id='CommandName' 
                                name='CommandName' 
                                type="text" 
                                placeholder= {"Nome"}
                                innerRef={custom_nameField}
                                value={partCommand?.custom_name}
                                invalidMessage = {"Nome inválido!"}
                                validationFunction = {(text) => isValidField(text)}
                                onchange={(text) => custom_nameValue.current = text}> 
                            </Input>

                            <Label text={"Key"} aling="flex-start"/>
                            <Input 
                                aling="flex-start"
                                id='key' 
                                name='key' 
                                type="text" 
                                placeholder= {"Key"}
                                innerRef={keyField}
                                invalidMessage = {"Key inválido!"}
                                value={partCommand?.key}
                                validationFunction = {(text) => isValidField(text)}
                                onchange={(text) => keyValue.current = text}> 
                            </Input>

                            <Label text={"Nome"} aling="flex-start"/>
                            <Input 
                                aling="flex-start"
                                id='name' 
                                name='name' 
                                type="text" 
                                placeholder= {"Nome"}
                                innerRef={nameField}
                                value={partCommand?.name}
                                invalidMessage = {"Nome inválido!"}
                                validationFunction = {(text) => isValidField(text)}
                                onchange={(text) => nameValue.current = text}> 
                            </Input>

                        </ContainerColumn>

                        <ContainerColumn>
                            <Label text={"Equipamento"} aling="flex-start"/>
                            <InputSelect
                                key={'equipment'}
                                name={'equipment'}
                                id={'equipment'}
                                placeholder={"Equipamento"}
                                invalidMessage = {"Equipamento inválida!"}
                                options={equipments}
                                innerRef={equipamentField}
                                value={partCommand?.equipmentId}
                                validationFunction = {(value) => isValidField(value)}
                                onchange={(value) => equipamentValue.current = value}>
                            </InputSelect>

                            <InputCheckbox text={t("inputs.isActive.label")} checked={partCommand?.active} onChange={(value)=> {isActiveValue.current = value; return true}}/>
                        </ContainerColumn>
                    </ContainerRow>

                    <ButtonsContainer>
                        <Button text={t("buttons.save")} width={'150px'} icon={<SaveIcon/>} onClick={()=>Save()}/>
                        <Button text={t("buttons.delete")} width={'150px'} color={'white-red'} onClick={async function(){
                            await Services.current.deleteEquipmentHasPartsCommand(id);
                            navigate('/EquipmentHasPartsCommands')
                        }} icon={<ImageIcon src={Excluir}/>}/>
                    </ButtonsContainer>
                </>}

            </Container>
        </>
    );
}

export default ViewEquipamentHasPartCommands;